// extracted by css-extract-rspack-plugin
module.exports =  {"textarea-wrapper":"Textarea-l1sB__textarea-wrapper","textarea-wrapper--has-label":"Textarea-KOaR__textarea-wrapper--has-label","dummy":"Textarea-EhND__dummy"};